import { z } from 'zod';
import { userPreferencesRowSchema, uuidSchema } from '../schema/rows.js';
/**
 * User preference commands (docs/08 §5 `user_preferences`, APA-03). The row has the same id as
 * the user, so the theme travels to every device of that user; the device-only choice never
 * reaches here (it stays in the browser).
 */
const setThemeInput = z.object({
    user_id: uuidSchema,
    theme: userPreferencesRowSchema.shape.theme,
});
/** Changes only the theme (PATCH with a single column, so it converges with other changes, S1). */
export function setTheme(input) {
    const parsed = setThemeInput.parse(input);
    return [
        {
            table: 'user_preferences',
            op: 'PATCH',
            id: parsed.user_id,
            data: { theme: parsed.theme },
        },
    ];
}
//# sourceMappingURL=preferences.js.map